import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { createSafeContext } from '@mantine/utils';
import { MENU_ERRORS } from './Menu.errors.js';

var _createSafeContext = createSafeContext(MENU_ERRORS.context),
    _createSafeContext2 = _slicedToArray(_createSafeContext, 2),
    MenuContextProvider = _createSafeContext2[0],
    useMenuContext = _createSafeContext2[1];

export { MenuContextProvider, useMenuContext };